import './card-section-heading.css';

export function CardSectionHeading({label}:{label:string}){
 return <div className="card-heading-controls"><span className="card-heading-rule" aria-hidden="true"/><h2 className="card-section-heading" data-ui="card-section-heading">{label}</h2><span className="card-heading-rule" aria-hidden="true"/></div>;
}
